import { computed } from 'vue';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useWohInputStore } from '@/features/Sparten/woh/useInputStore';
import { useWohContractStore } from '@/features/Sparten/woh/useContractStore';

export const hasAbleitungsrohre = computed(
  () =>
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.ABLEITUNGSROHRE,
      SIMPLE_CHOICE_META.ABLEITUNGSROHRE_NICHT_WICHTIG,
    ).includes(useWohInputStore().ableitungsrohre.innerhalb) ||
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.ABLEITUNGSROHRE,
      SIMPLE_CHOICE_META.ABLEITUNGSROHRE_NICHT_WICHTIG,
    ).includes(useWohInputStore().ableitungsrohre.ausserhalb),
);

export const hasSanierungen = () => useWohInputStore().sanierung;

export const hasSanierungenReactive = computed(() => hasSanierungen());

export const hasSanierungSanitaerleitung = () =>
  hasSanierungen() && useWohInputStore().sanierungen.sanitaerleitungen;

export const hasSanierungSanitaerleitungReactive = computed(() =>
  hasSanierungSanitaerleitung(),
);

export const hasSanierungElektroleitung = () =>
  hasSanierungen() && useWohInputStore().sanierungen.elektroleitungen;

export const hasSanierungElektroleitungReactive = computed(() =>
  hasSanierungElektroleitung(),
);

export const hasSanierungDach = () =>
  hasSanierungen() && useWohInputStore().sanierungen.dach;

export const hasSanierungDachReactive = computed(() => hasSanierungDach());

export const hasSanierungHeizungsrohre = () =>
  hasSanierungen() && useWohInputStore().sanierungen.heizungsrohre;

export const hasSanierungHeizungsrohreReactive = computed(() =>
  hasSanierungHeizungsrohre(),
);

export const hasSanierungSonstige = () =>
  hasSanierungen() && useWohInputStore().sanierungen.sonstige;

export const hasSanierungSonstigeReactive = computed(() =>
  hasSanierungSonstige(),
);

export const hasVorschaeden = () => useWohInputStore().vorschaden;

export const hasVorschaedenReactive = computed(() => hasVorschaeden());

export const hasVorschadenLeitungswasser = () =>
  hasVorschaeden() && useWohInputStore().vorschaeden.leitungswasser;

export const hasVorschadenLeitungswasserReactive = computed(() =>
  hasVorschadenLeitungswasser(),
);

export const hasVorschadenSturmHagel = () =>
  hasVorschaeden() && useWohInputStore().vorschaeden.sturmHagel;

export const hasVorschadenSturmHagelReactive = computed(() =>
  hasVorschadenSturmHagel(),
);

export const hasVorschadenFeuerBlitz = () =>
  hasVorschaeden() && useWohInputStore().vorschaeden.feuerBlitz;

export const hasVorschadenFeuerBlitzReactive = computed(() =>
  hasVorschadenFeuerBlitz(),
);

export const showVorschadenElementar = () =>
  hasVorschaeden() &&
  useWohInputStore().absicherungen !== undefined &&
  useWohInputStore().absicherungen.elementar;

export const showVorschadenElementarReactive = computed(() =>
  showVorschadenElementar(),
);

export const showVorschadenGlasversicherung = () =>
  hasVorschaeden() && useWohInputStore().absicherungen.glasversicherung;

export const showVorschadenGlasversicherungReactive = computed(() =>
  showVorschadenGlasversicherung(),
);

export const hasVorschadenElementar = () =>
  showVorschadenElementar() && useWohInputStore().vorschaeden.elementar;

export const hasVorschadenElementarReactive = computed(
  () => showVorschadenElementar() && useWohInputStore().vorschaeden.elementar,
);

export const hasVorschadenGlas = () =>
  showVorschadenGlasversicherung() && useWohInputStore().vorschaeden.glas;

export const hasVorschadenGlasReactive = computed(
  () => showVorschadenGlasversicherung() && useWohInputStore().vorschaeden.glas,
);

export const hasElementarDamage = computed(
  () =>
    hasVorschadenElementar() &&
    useWohContractStore().vorschaden.vorschadenElementar,
);

export const hasGlasDamage = computed(
  () => hasVorschadenGlas() && useWohContractStore().vorschaden.vorschadenGlas,
);

export const hasVorschadenSonstige = () =>
  hasVorschaeden() && useWohInputStore().vorschaeden.sonstige;

export const hasVorschadenSonstigeReactive = computed(() =>
  hasVorschadenSonstige(),
);

export const isMehrfamilienhaus = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.GEBAEUDEART,
    SIMPLE_CHOICE_META.REQUIRES_UNITS,
  ).includes(useWohInputStore().gebaeudeart);

export const isMehrfamilienhausReactive = computed(() => isMehrfamilienhaus());

export const isNotMehrfamilienhaus = computed(
  () =>
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.GEBAEUDEART,
      SIMPLE_CHOICE_META.REQUIRES_UNITS,
    ).includes(useWohInputStore().gebaeudeart),
);

export const hasKeller = computed(() => useWohInputStore().keller);

export const hasDachgeschoss = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.DACHGESCHOSS,
    SIMPLE_CHOICE_META.DACHGESCHOSS,
  ).includes(useWohInputStore().dachgeschoss);

export const hasDachgeschossReactive = computed(() => hasDachgeschoss());

export const hasPhotovoltaik = () => useWohInputStore().photovoltaikVorhanden;

export const hasPhotovoltaikReactive = computed(() => hasPhotovoltaik());

export const isPhotovoltaikMitversichert = () =>
  hasPhotovoltaik() &&
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.PHOTOVOLTAIK_MITVERSICHERUNG,
    SIMPLE_CHOICE_META.REQUIRES_UNITS,
  ).includes(useWohInputStore().photovoltaik.mitversicherung);

export const isPhotovoltaikMitversichertReactive = computed(() =>
  isPhotovoltaikMitversichert(),
);

export const isVersicherungssummeTypeWert1914 = computed(
  () => useWohInputStore().nutzeWert1914,
);

export const isVersicherungssummeTypeNeubauwert = computed(
  () => !useWohInputStore().nutzeWert1914,
);

export const isCommercialUse = computed(
  () => useWohContractStore().gewerblicheNutzung as boolean,
);

export const hasDoctorsOffice = computed(
  () =>
    isCommercialUse.value &&
    (useWohContractStore().gewerbeGebaeude.anzahlPraxen ?? 0) > 0,
);

export const hasOffice = computed(
  () =>
    isCommercialUse.value &&
    (useWohContractStore().gewerbeGebaeude.anzahlBueros ?? 0) > 0,
);

export const hasOtherBusinesses = computed(
  () =>
    isCommercialUse.value &&
    (useWohContractStore().gewerbeGebaeude.anzahlSonstigeGewerbe ?? 0) > 0,
);

export const hasGebaeudeImBau = computed(
  () => useWohContractStore().gebaeudeImBau as boolean,
);
